<template>
		<div class="campaign-information-wrapper">
				<form action="#"
				      @submit.prevent="submitForm"
				      class="form"
				      ref="form"
				>
						<div class="row">
								<div class="col-sm-12" v-if="showTitle">
										<h3 class="text-left text-normal">	
												Suggested Donation Amounts
										</h3>
								</div>
								<div class="col-sm-12">
									<p class="donation-amount"> 
									Enter your donation amounts
									</p>
								</div>
								<div class="col-sm-12">
										<div class="text-left text-danger" v-if="errors.has('internalError')">
												There was an error with the input you provided. Please try again.
										</div>
								</div>
						</div>

						<div class="margin-top-40 margin-bottom-20">
								<div class="row">
										<div class="col-md-4">
												<div class="form-group">
														<currency-input v-model="formData.predefined_donation_1" class="hh-input-label" label="Amount One" required/>

														<div class="invalid-feedback-red" v-if="errors.has('predefined_donation_1')">
																{{errors.get('predefined_donation_1')}}
														</div>
												</div>
										</div>

										<div class="col-md-4">
												<div class="form-group">
														<currency-input v-model="formData.predefined_donation_2" class="hh-input-label" label="Amount Two" required/>

														<div class="invalid-feedback-red" v-if="errors.has('predefined_donation_2')">
																{{errors.get('predefined_donation_2')}}
														</div>
												</div>
										</div>
												<div class="col-md-4">
														<div class="form-group">
																<currency-input v-model="formData.predefined_donation_3" class="hh-input-label" label="Amount Three" required/>

																<div class="invalid-feedback-red" v-if="errors.has('predefined_donation_3')">
																		{{errors.get('predefined_donation_3')}}
																</div>
														</div>
												</div>

										</div>
								</div>

				<div class="row margin-bottom-20 margin-top-20 buttons-wrapper"  v-if="!isLoading">
					<div class="form-group col-sm-6" v-if="!editMode">
						<button type="button" @click="saveAsDraftAction"
						        class="btn hh-btn back-btn btn-responsive" name="Save as draft">
							Save as Draft
						</button>
					</div>
					<div class="form-group col-sm-6" v-if="!editMode">
						<button type="submit" :disabled="!isFormReady"
						        class="btn save-btn hh-btn-green btn-responsive" name="Continue to social links">
						Continue to Social Links
						</button>
					</div>
					<div class="form-group col-sm-6" v-if="editMode">
						<button type="button" v-on:click="backAction"
						        class="btn hh-btn back-btn" name="Cancel">
							Cancel
						</button>
					</div>
					<div class="form-group col-sm-6" v-if="editMode">
						<button type="submit" :disabled="!isFormReady"
						        class="btn hh-btn save-btn hh-btn-green" name="Save changes">
							Save Changes
						</button>
					</div>			
					<div class="form-group col-sm-12 back-row" v-if="!editMode">
						<div class="col-md-12 text-center margin-bottom-20">
							<img src="/dist/site/static/icons/go_back.svg" style="transform: rotate(180deg);" alt="Go back">
							<span style="font-family: Circular Std;font-size: 16px;line-height: 16px;text-align: center;letter-spacing: 0.005em;color: #ACACAC;"
								v-on:click="backAction">Go Back</span>
						</div>
					</div>
				</div>
				</form>
		</div>
</template>

<script>
	import {mapActions} from 'vuex'
	import InputLabel from '../form/elements/InputLabel'
	import TextEditor from '../form/elements/TextEditor'
	import CurrencyInput from '../form/elements/CurrencyInput'
	import vSelect from 'vue-select'
	import { scrollTo } from '../../utils/componentHelper'

	export default {
		name: 'SuggestedDonationAmounts',

		components: {
			InputLabel,
			TextEditor,
			CurrencyInput,
			vSelect,
		},

		props: {
			campaignData: Object,
			campaignImages: Object,
			staticData: {
				states: Object,
			},
			showTitle: {
				type: Boolean,
				default: true,
			},
			showSkipButton: {
				type: Boolean,
				default: true,
			},
			showSaveAsDraft: {
				type: Boolean,
				default: true,
			},
			editMode: {
				type: Boolean,
				default: false,
			},
		},

		data: () => {
			return {
				loading: true,
				dataAnalysed: false,
				forceRecompute: 0,
				campaignSlug: null,
				componentsLoadingStatus: {},
				formData: {
					informationType: 'campaign-suggested-donation-amounts',
					method: 'put',
					withFiles: false,
					step: 2,

					predefined_donation_1: null,
					predefined_donation_2: null,
					predefined_donation_3: null,
				},
			}
		},

		beforeMount() {
			this.campaignSlug = this.campaignData.slug

			this.formData.predefined_donation_1 = this.campaignData.predefined_donation_1 ? parseFloat(this.campaignData.predefined_donation_1) : 0
			this.formData.predefined_donation_2 = this.campaignData.predefined_donation_2 ? parseFloat(this.campaignData.predefined_donation_2) : 0
			this.formData.predefined_donation_3 = this.campaignData.predefined_donation_3 ? parseFloat(this.campaignData.predefined_donation_3) : 0

			this.loading = false
		},

		mounted() {
		},

		methods: {
			...mapActions('campaign', ['storeInformation', 'saveAsDraft']),

			cancelAction() {
				window.location = '/dashboard'
			},

			backAction() {
				this.$emit('navigateBack')
			},

			skipAction() {
				this.$emit('navigateNext')
			},

			componentLoading(componentName, value) {
				this.componentsLoadingStatus[componentName] = value
			},

			submitForm() {
				this.loading = true
				this.formData.campaignSlug = this.campaignSlug

				this.storeInformation(this.formData).then(() => {
					this.forceRecompute++
					this.loading = false
					if (this.status === 'success') {
						this.$emit('formSubmitted')
					} else {
						scrollTo(this.$refs['form'])
					}

				})
			},

			saveAsDraftAction() {
				this.loading = true
				this.formData.campaignSlug = this.campaignSlug

				this.storeInformation(this.formData).then(() => {
					if (this.status === 'success') {
						this.$emit('formSubmitted')
            this.saveAsDraft(this.campaignSlug);
            this.loading = false;
              this.forceRecompute++;
              this.cancelAction();
            
					} else {
						scrollTo(this.$refs['form'])
					}
				})
			},

			placeholderImpactItem(item) {
				if (item === 1) {
					return "1 lunch\n" +
						"2 pairs of socks\n" +
						"1 toothbrush\n" +
						"1 tube of toothpaste"
				} else if (item === 2) {
					return '3 lunch\n' +
						'6 pairs of socks\n' +
						'2 toothbrush\n' +
						'2 tube of toothpaste'
				} else if (item === 3) {
					return '10 lunch\n' +
						'20 pairs of socks\n' +
						'10 toothbrush\n' +
						'10 tube of toothpaste'
				}

				return ''
			}
		},

		computed: {
			isDataFetched() {
				return !_.isEmpty(this.campaignData)
			},

			storeInformationData: {
				get() {
					return this.$store.getters['campaign/storeInformationData'](this.campaignSlug, this.formData.informationType, this.forceRecompute)
				},
			},

			status: {
				get() {
					return this.$store.getters['campaign/storeInformationStatus'](this.campaignSlug, this.formData.informationType, this.forceRecompute)
				},
			},

			errors: {
				get() {
					return this.$store.getters['campaign/storeInformationErrors'](this.campaignSlug, this.formData.informationType, this.forceRecompute)
				},
			},

			saveAsDraftData: {
				get() {
					return this.$store.getters['campaign/saveAsDraftData'](this.campaignSlug, this.forceRecompute)
				},
			},

			isLoading() {
				for (let component in this.componentsLoadingStatus) {
					if (this.componentsLoadingStatus[component]) {
						return true
					}
				}

				return this.loading
			},

			isFormReady() {
				return !this.loading
			},
		},

		watch: {
			isLoading(to, from) {
				this.$emit('componentLoading', 'campaignComponent', to)
			}
		}
	}
</script>

<style scoped>
	h3 {
		font-family: Circular Std;font-style: normal;font-weight: 500;font-size: 20px;line-height: 14px;color: #000000;
	}

	.donation-amount {
		font-family: Circular Std;
		font-style: normal;
		font-weight: 450;
		font-size: 14px;
		line-height: 15px;color: #AEAEAE;
	}

	.draft-btn {
		font-family: Circular Std;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 16px;
		text-align: center;
		letter-spacing: 0.005em;
		color: #ACACAC;
	}

	.back-row {
		cursor: pointer;
	}
</style>
